// 22.1.2.2 / 15.4.3.2 Array.isArray(arg)
var $export = require('./_export');

$export($export.S, 'Array', { isArray: require('./_is-array') });



//////////////////
// WEBPACK FOOTER
// ./node_modules/_core-js@2.6.9@core-js/library/modules/es6.array.is-array.js
// module id = ./node_modules/_core-js@2.6.9@core-js/library/modules/es6.array.is-array.js
// module chunks = 6